/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type SenderIdRequestStatus = 0 | 1 | 2 | 3 | 4 | 5;

export const SenderIdRequestStatus = {
    NUMBER_0: 0 as SenderIdRequestStatus,
    NUMBER_1: 1 as SenderIdRequestStatus,
    NUMBER_2: 2 as SenderIdRequestStatus,
    NUMBER_3: 3 as SenderIdRequestStatus,
    NUMBER_4: 4 as SenderIdRequestStatus,
    NUMBER_5: 5 as SenderIdRequestStatus
};
